//Imports from same Package: none

import {
  type FormatToolbarButtonsType,
  CONTENT_EDITOR_MENUS,
} from '@packages/systems/ContentEditor';

export const REGENERATE_SELECTION = 'REGENERATE_SELECTION' as const;

export const MSG_ERROR_ON_CANVAS_EDITING =
  'Unable to save changes to CMS item.';

export const CONTENT_EDITOR_AI_TOOLBARS = new Set([
  CONTENT_EDITOR_MENUS.AI_EDIT_MENU,
  CONTENT_EDITOR_MENUS.AI_PROMPT_MENU,
  CONTENT_EDITOR_MENUS.AI_LOADING_BAR,
]);

export type FormatButton = keyof FormatToolbarButtonsType | 'customclass';

// NOTE: Many of these enums/maps are lowercase to work with the legacy RTFormatToolbar
// that the contentEditor is temporarily using. Once we remove the legacy RTE
// we can make the shortcuts uppercase and use $Keys<typeof SHORTCUTS>; as the type
export type ShortcutsType = string;

// Valid characters for Number field input validation
export const VALID_NUMBER_CHARS = new Set([
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '.',
  ',',
  '-',
]);
